<template>
  <div class="wrap" :class='device=="mobile"?"mobile":""' v-loading="pageLoading">
    <div class="bg"></div>
    <div class="logo" @click='$router.go(0)'></div>
    <div class="link-btn"><a target="_blank" href="https://www.zshuchain.com/index.html">中数链官网</a></div>
    <div class="search-box">
      <div class="title">
        {{ title }}<el-tag class="env" v-if="env" effect="dark" :size='device=="mobile"?"mini":""'>{{
          env
        }}</el-tag>
      </div>
      <div class="input-box">
        <div class="dropholder" :class='menusShow?"show":""'>
          <div v-if="figureShow && !selectVal && device!='mobile'" class="finge"></div>
          <div class="dropdown" @click="menusShow = !menusShow">
            {{ selectVal || "请选择" }}
          </div>
          <ul class="menu" :class="menusShow ? 'showMenu' : ''">
            <li v-for="item in types" @click="chooseTypeFn(item)">
              {{ item.val }}
            </li>
          </ul>
        </div>
        <form onsubmit="event.preventDefault();" role="search">
          <label for="search">区块链搜索</label>
          <input
            id="search"
            type="search"
            :placeholder="placeholderMessage"
            autofocus=""
            autocomplete="off"
            @input="inputChange($event)"
          />
          <button type="submit" @click="searchFn"></button>
        </form>
      </div>
      <div class="msg">上海文化产权交易所（长江）数字IP基地<br/>国家级版权交易保护联盟链超级节点<br/>文化投行机构</div>
      <!-- <div class="btn-box">
        <router-link :to='"/assets"'><div><span></span><span></span><span></span><span></span>资产发布信息</div></router-link>
        <router-link :to='"/trade"'><div><span></span><span></span><span></span><span></span>交易哈希信息</div></router-link>
        <router-link :to='"/address"'><div><span></span><span></span><span></span><span></span>用户钱包地址</div></router-link>
        <router-link :to='"/block"'><div><span></span><span></span><span></span><span></span>区块高度信息</div></router-link>
      </div> -->
    </div>
    <div class="bottom-no">
      <span>© 2022 中数链（上海）文化发展有限公司 版权所有</span>
      <a href="https://beian.miit.gov.cn/" target='_blank'>沪ICP备2022017589号-1</a>
    </div>
    <div v-if="toastVisible" class="toast-box">
      没有找到你搜索的内容
    </div>
  </div>
</template>

<script>
import { Loading, MessageBox } from "element-ui";
import setting from '@/settings.js'
import { validateSearchVal } from '@/utils/validate'
import { mapGetters } from 'vuex'
import { assetsTable as address } from '@/api/address'
import { main as trade } from '@/api/trade'
import { main as assets } from '@/api/assets'
import { main as block } from '@/api/block'


export default {
  name: "Index",
  components: {},
  data() {
    return {
      pageLoading: false,
      title: setting.title,
      env: process.env.VUE_APP_ENV,
      placeholderMessage: "支持搜索主资产编号/交易哈希/钱包地址/区块高度",
      tipMessage: "请输入主资产编号",
      types: [
        {
          val: "资产发布信息",
          path: "assets",
          msg: "请输入主资产编号",
        },
        {
          val: "交易哈希信息",
          path: "trade",
          msg: "请输入交易哈希",
        },
        {
          val: "用户钱包地址",
          path: "address",
          msg: "请输入钱包地址",
        },
        {
          val: "区块高度信息",
          path: "block",
          msg: "请输入区块高度",
        },
      ],
      figureShow: false,
      menusShow: false,
      selectVal: "",
      path: "",
      key: "",
      toastVisible: false
    };
  },
  computed: {
    ...mapGetters([
      'device'
    ]),
  },
  watch: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    inputChange(e) {
      this.key = e.target.value;
    },
    chooseTypeFn(item) {
      let { val, path } = item;
      this.path = path;
      this.selectVal = val;
      this.menusShow = false;
      this.placeholderMessage = item.msg;
      this.tipMessage = item.msg;
    },
    searchFn() {
      if (!this.key) {
        MessageBox.confirm("搜索内容不能为空", "", {
          confirmButtonText: "确定",
          showCancelButton: false,
          // type: 'info',
          center: true,
        }).then();
        return;
      }
      if (!validateSearchVal(this.key)) {
        MessageBox.confirm("搜索内容格式不正确", "", {
          confirmButtonText: "确定",
          showCancelButton: false,
          // type: 'info',
          center: true,
        }).then();
        return;
      }
      if (!this.selectVal) {
        MessageBox.confirm("请选择搜索类型", "", {
          confirmButtonText: "确定",
          showCancelButton: false,
          // type: 'warning',
          center: true,
        }).then(() => {
          this.figureShow = true;
        });
        return;
      }
      this.pageLoading = true
      this[this.path+"Req"]()
    },
    assetsReq() {
      assets(this.key).then(response => this.reqCb(response)).catch(this.errorCb)
    },
    tradeReq() {
      trade({
        TransactionHash: this.key
      }).then(response => this.reqCb(response)).catch(this.errorCb)
    },
    addressReq() {
      address({
        maxResultCount: 10,
        skipCount: 0,
        walletAddr: this.key,
      }).then(response => this.reqCb(response)).catch(this.errorCb)
    },
    blockReq() {
      block({
        maxResultCount: 10,
        skipCount: 0,
        blockHeight: this.key,
      }).then(response => this.reqCb(response)).catch(this.errorCb)
    },
    reqCb(response) {
      this.pageLoading = false
      if(response.code == "402") {
        this.toastVisible = true
        setTimeout(() => {
          this.toastVisible = false
        }, 2000)
      }else {
        this.$store.dispatch('app/cacheData', response.data)
        this.$router.push({ name: this.path, query: { key: this.key } });
      }
    },
    errorCb() {
      this.pageLoading = false
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.wrap {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100%;
  width: 100%;
  overflow: hidden;
  min-width: 1200px;
  // background: #050A34 url('~@/assets/bg.jpg') no-repeat center center / cover;
  .toast-box {
    position: absolute;
    width: 250px;
    height: 60px;
    line-height: 60px;
    background: rgba(0, 0, 0, 0.6);
    color: #fff;
    z-index: 99999;
    text-align: center;
    font-size: 16px;
    opacity: 1;
    transition: 0.2s;
    z-index: 999;
  }
  .bg {
    position: absolute;
    width: 100%;
    height: 100%;
    background: #fff url("~@/assets/bg.jpeg") no-repeat center center / cover;
    z-index: 1;
    // animation: animate5 2s linear 1;
    animation-fill-mode: forwards;
    transform: scale(1);
  }
  @keyframes animate5 {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(1.1);
    }
  }
  .logo {
    position: absolute;
    left: 10%;
    top: 5%;
    width: 204px;
    height: 36px;
    background: no-repeat url('~@/assets/logo.png') center / contain;
    z-index: 2;
    cursor: pointer;
  }
  .link-btn {
    position: absolute;
    right: 10%;
    top: 5%;
    width: auto;
    height: 35px;
    background: rgba(0, 102, 255, 0.15);
    color: #0267ff;
    line-height: 35px;
    z-index: 2;
    text-align: center;
    cursor: pointer;
    border-radius: 3px;
    font-size: 14px;
    font-weight: 600;
    >a {
      display: block;
      padding: 0 15px;
      width: 100%;
      height: 100%;
    }
  }
  .bottom-no {
    position: absolute;
    bottom: 30px;
    left: 0;
    right: 0;
    display: flex;
    z-index: 2;
  }
  .bottom-no>span, .bottom-no>a {flex: 1;padding: 0 30px;font-size: 12px;color: #666; }
  .bottom-no>span { text-align: right; }
  .bottom-no>a { text-align: left; }

  .search-box {
    position: absolute;
    left: 50%;
    top: 30%;
    transform: translateX(-50%) translateY(0);
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 50%;
    z-index: 2;
    .title {
      position: relative;
      color: #333;
      font-size: 54px;
      letter-spacing: 4px;
      font-weight: 600;
      margin-bottom: 80px;
      opacity: 0.95;
      // text-shadow: 0 0 20px rgba(93, 123, 232, 0.5);
      .env {
        position: absolute;
        bottom: 10%;
        left: 105%;
        // transform: translateY(-50%);
        letter-spacing: 0px;
      }
    }
  }

  .input-box {
    position: relative;
    display: flex;
    width: 100%;
    form {
      position: relative;
      flex: 1;
      background: $primaryColor;
      border-radius: 7px;
      box-shadow: 0 0 15px rgba(71, 106, 233, 0.4);
      input,
      button {
        width: 60px;
        height: 54px;
        border: 0;
        color: #333;
        font-size: 16px;
      }
      input::-webkit-input-placeholder {
        color: rgba(0, 102, 255, 0.3);
      }
      input::-moz-placeholder {
        color: rgba(0, 102, 255, 0.3);
      }
      input:-ms-placeholder {
        color: rgba(0, 102, 255, 0.3);
      }
      input[type="search"] {
        outline: 0;
        width: 100%;
        line-height: 54px;
        font-size: 16px;
        background: #fff;
        padding: 0 16px;
        border: 1px solid $primaryColor;
        border-radius: 7px;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        transition: all 0.3s cubic-bezier(0, 0, 0.43, 1.49);
        transition-property: width, border-radius;
        z-index: 1;
        position: relative;
      }

      button {
        display: none;
        position: absolute;
        top: 0;
        right: 0;
        width: 70px;
        font-weight: bold;
        background-color: $primaryColor;
        border-radius: 0 7px 7px 0;
        background: no-repeat
          url(data:image/png;base64,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)
          center / 30px 30px;
        cursor: pointer;
      }
      button:hover {
        background-color: rgba(0, 102, 255, 0.3);
      }


      input:not(:placeholder-shown) {
        border-radius: 7px 0 0 7px;
        width: calc(100% - 70px);
      }

      input:not(:placeholder-shown) + button {
        display: block;
      }

      label {
        position: absolute;
        clip: rect(1px, 1px, 1px, 1px);
        padding: 0;
        border: 0;
        height: 1px;
        width: 1px;
        overflow: hidden;
      }
    }

    //下拉框样式
    .dropholder {
      margin-right: 5px;
      width: 150px;
      height: 54px;
      font: 18px arial;
      color: #fff;
      position: relative;
      animation: move 3s ease-in-out infinite;
      position: relative;
      cursor: pointer;
      font-size: 16px;

      &.show {
        &:after {
          content: none;
        }
        .dropdown:after {
          transform: rotate(-180deg);
        }
      }
    }

    .finge {
      position: absolute;
      top: 50%;
      right: 120%;
      transform: translateY(-50%) rotate(-90deg);
      width: 40px;
      height: 73px;
      background: no-repeat url("~@/assets/guide_finge.png") center / contain;
      animation: fingeMove 1s ease-in-out infinite;
    }

    .dropholder:hover,
    .dropholder:hover:after {
      animation-play-state: paused;
    }

    .dropholder:after {
      content: "";
      position: absolute;
      width: 190px;
      height: 5px;
      background: rgba(0, 0, 0, 0);
      display: block;
      top: 100px;
      left: -20px;
      margin: auto;
      border-radius: 50%;
      box-shadow: 0 15px 10px rgba(0, 0, 0, 0.5);
      animation: moveShadow 3s ease-in-out infinite;
    }

    .dropdown {
      height: 54px;
      line-height: 54px;
      // border: 1px solid $primaryColor;
      border-radius: 10px;
      padding-right: 10px;
      text-align: center;
      background: linear-gradient(135deg, $primaryColor, $primaryColor);
      font-weight: 500;
      letter-spacing: 0px;
    }

    .dropdown:after {
      content: "▾";
      font-size: 25px;
      position: absolute;
      right: 10px;
      top: 0px;
      display: block;
      transform: rotate(0deg);
      transition: 0.3s;
    }

    .menu {
      position: absolute;
      padding: 0;
      right: 0;
      top: 50px;
      width: 150px;
      cursor: pointer;
      opacity: 0;
      transform-style: preserve-3d;
      transform: rotatey(180deg) rotateX(5deg) translatey(100px);
      backface-visibility: hidden;
      background: linear-gradient($primaryColor, $primaryColor);
      // border: 2px solid #254ddd;
      border-radius: 10px;
      transition: all 0.8s;
      z-index: 5;
      overflow: hidden;
    }

    .menu li {
      list-style: none;
      padding: 14px 10px;
      border-bottom: 1px solid rgba($color: #fff, $alpha: 0.2);
      color: #e8f8ff;
      transition: all 0.3s;
      font-size: 13px;
      text-align: center;
      letter-spacing: 1px;
    }

    .menu li:hover {
      background: #0559d8;;
      // padding-left: 20px
    }

    .menu li:last-child {
      border: 0;
    }

    .showMenu {
      opacity: 1;
      transform: rotateX(0deg) translatey(0px);
    }

    i {
      opacity: 0.7;
    }
  }
  .msg {
    margin-top: 30px;
    font-size: 14px;
    color: #133870;
    line-height: 20px;
    text-align: center;
    font-weight: 400;
  }
}

.mobile.wrap {
  min-width: auto;
  .logo {
    width: 204*0.6px;
    height: 36*0.6px;
  }
  .link-btn {
    height: 35*0.7px;
    font-size: 10px;
    line-height: 35*0.7px;
    >a {
      padding: 0 7px;
    }
  }

  .search-box {
    width: 85%;
    .title {
      font-size: 54*0.5px;
      letter-spacing: 4*0.5px;
      margin-bottom: 80*0.5px;
    }
  }

  .input-box {
    form {
      border-radius: 7*0.5px;
      box-shadow: 0 0 15*0.5px rgba(71, 106, 233, 0.4);
      input,
      button {
        width: 60*0.5px;
        height: 54*0.5px;
        font-size: 11px;
      }
      input[type="search"] {
        padding: 3px 0;
        width: 100%;
        line-height: 20px;
        font-size: 12px;
        padding: 0 16*0.5px;
        border: thin solid $primaryColor;
        border-radius: 7*0.5px;
        box-sizing: border-box;
      }

      button {
        width: 70*0.5px;
        border-radius: 0 7*0.5px 7*0.5px 0;
        background-size: 30*0.5px 30*0.5px;
      }
     
      input:not(:placeholder-shown) {
        border-radius: 7*0.5px 0 0 7*0.5px;
        width: calc(100% - 70*0.5px);
      }

      label {
        clip: rect(1*0.5px, 1*0.5px, 1*0.5px, 1*0.5px);
        height: 1*0.5px;
        width: 1*0.5px;
      }
    }

    //下拉框样式
    .dropholder {
      margin-right: 5*0.5px;
      width: 150*0.5px;
      height: 54*0.5px;
      font-size: 10px;
    }

    .finge {
      width: 40*0.5px;
      height: 73*0.5px;
    }

    .dropholder:hover,
    .dropholder:hover:after {
      animation-play-state: running;
    }

    .dropholder:after {
      width: 190*0.5px;
      height: 5*0.5px;
      top: 100*0.5px;
      left: -20*0.5px;
      box-shadow: 0 15*0.5px 10*0.5px rgba(0, 0, 0, 0.5);
    }

    .dropdown {
      height: 54*0.5px;
      line-height: 54*0.5px;
      // border: 1*0.5px solid $primaryColor;
      border-radius: 10*0.5px;
      padding-right: 10*0.5px;
      letter-spacing: 0px;
    }

    .dropdown:after {
      content: "▾";
      font-size: 12px;
      position: absolute;
      right: 2px;
      top: 0px;
      display: block;
      transform: rotate(0deg);
      transition: 0.3s;
    }

    .menu {
      top: 50*0.5px;
      width: 150*0.5px;
      transform: rotatey(180deg) rotateX(5deg) translatey(100*0.5px);
      border-radius: 10*0.5px;
    }

    .menu li {
      padding: 14*0.5px 10*0.5px;
      border-bottom: thin solid rgba($color: #fff, $alpha: 0.2);
      font-size: 10px;
      text-align: center;
      letter-spacing: 0px;
    }

    .showMenu {
      transform: rotateX(0deg) translatey(0px);
    }
  }
  
  .msg {
    font-size: 11px;
    line-height: 16px;
  }

  .bottom-no {
    bottom: 15px;
    flex-direction: column;
  }
  .bottom-no>span, .bottom-no>a {font-size: 10px;}
  .bottom-no>span { text-align: center; }
  .bottom-no>a { text-align: center; }
}

@keyframes fingeMove {
  0%,
  100% {
    right: 120%;
  }

  50% {
    right: 130%;
  }
}

@keyframes move {
  0%,
  100% {
    transform: translateY(-5px);
  }

  50% {
    transform: translateY(5px);
  }
}

@keyframes moveShadow {
  0%,
  100% {
    transform: translateY(10px);
    opacity: 0.4;
  }

  50% {
    transform: translateY(0);
    opacity: 1;
  }
}

// .btn-box {
//   display: flex;
//   justify-content: space-between;
//   margin-top: 50px;
//   width: 100%;
//   div {
//     position: relative;
//     display: inline-block;
//     padding: 10px 15px;
//     color: #fff;
//     text-decoration: none;
//     text-transform: uppercase;
//     transition: .5s;
//     letter-spacing: 1px;
//     overflow: hidden;
//     font-size: 14px;
//     background: rgba(93, 123, 232, 0.5);
//     cursor: pointer;
//     &:hover {
//       background: rgb(93, 123, 232); //#03e9f4
//       color: #fff;
//       box-shadow: 0 0 5px $primaryColor, 0 0 25px $primaryColor, 0 0 50px $primaryColor, 0 0 200px $primaryColor;
//       -webkit-box-reflect: below 1px linear-gradient(transparent,#0005);
//     }
//     span {
//       position: absolute;
//     }
//     span:nth-child(1) {
//       top: 0;
//       left: 0;
//       width: 100%;
//       height: 2px;
//       background: linear-gradient(90deg,transparent,#fff);
//       animation: animate1 1s linear infinite;
//     }
//     span:nth-child(2) {
//       top: -100%;
//       right: 0;
//       width: 2px;
//       height: 100%;
//       background: linear-gradient(180deg,transparent,#fff);
//       animation: animate2 1s linear infinite;
//       animation-delay: .25s;
//     }
//     span:nth-child(3) {
//       bottom: 0;
//       right: 0;
//       width: 100%;
//       height: 2px;
//       background: linear-gradient(270deg,transparent,#fff);
//       animation: animate3 1s linear infinite;
//       animation-delay: .50s;
//     }
//     span:nth-child(4) {
//       bottom: -100%;
//       left: 0;
//       width: 2px;
//       height: 100%;
//       background: linear-gradient(360deg,transparent,#fff);
//       animation: animate4 1s linear infinite;
//       animation-delay: .75s;
//     }
//   }
//   .btn {
//     width: 110px;
//     height: 45px;
//     line-height: 40px;
//     font-size: 14px;
//     border: 2px dashed #57bd84;
//     border-radius: 5px;
//     background: rgba(255, 255, 255, 0.171);
//     text-align: center;
//     color: #57bd84;
//     font-weight: 700;
//   }
// }
// @keyframes animate1{0%{left:-100%}50%,100%{left:100%}}
// @keyframes animate2{0%{top:-100%}50%,100%{top:100%}}
// @keyframes animate3{0%{right:-100%}50%,100%{right:100%}}
// @keyframes animate4{0%{bottom:-100%}50%,100%{bottom:100%}}
</style>
